export const calculateDefaults = (intake) => {
  const defaults = {};
  
  if (!intake) return defaults;

  const { researchGoal, dataAvailability, timeline, expertise } = intake;

  if (researchGoal === 'explore') {
    defaults.philosophy = 'interpretivism';
    defaults.approach = 'qualitative';
  } else if (researchGoal === 'test') {
    defaults.philosophy = 'positivism';
    defaults.approach = 'quantitative';
  } else if (researchGoal === 'understand') {
    defaults.philosophy = 'interpretivism';
    defaults.approach = 'qualitative';
  } else if (researchGoal === 'explain') {
    defaults.philosophy = 'positivism';
    defaults.approach = 'quantitative';
  } else if (researchGoal === 'mixed') {
    defaults.philosophy = 'pragmatism';
    defaults.approach = 'mixed';
  }

  if (dataAvailability === 'existing_quantitative') {
    defaults.approach = defaults.approach || 'quantitative';
  } else if (dataAvailability === 'existing_qualitative') {
    defaults.approach = defaults.approach || 'qualitative';
  } else if (dataAvailability === 'will_collect') {
    defaults.approach = defaults.approach || 'qualitative';
  }

  if (timeline === 'short') {
    defaults.timeHorizon = 'cross_sectional';
  } else if (timeline === 'long') {
    defaults.timeHorizon = 'longitudinal';
  }

  return defaults;
};

export const getRecommendedStrategies = (philosophy, approach) => {
  const strategies = [];

  if (approach === 'quantitative') {
    strategies.push('survey', 'experiment', 'archival');
  } else if (approach === 'qualitative') {
    strategies.push('case_study', 'ethnography', 'grounded_theory', 'narrative', 'phenomenology');
  } else if (approach === 'mixed') {
    strategies.push('sequential_explanatory', 'sequential_exploratory', 'convergent', 'embedded');
  }

  return strategies;
};

export const validateSelection = (selection, requirements) => {
  const warnings = [];
  
  if (requirements.philosophy && selection.philosophy !== requirements.philosophy) {
    warnings.push({
      type: 'mismatch',
      message: `Your selection may not align with your stated research goals.`
    });
  }

  return warnings;
};

export const generateExplanation = (step, selection, context) => {
  const explanations = {
    philosophy: {
      positivism: 'You selected Positivism, which emphasizes objective measurement and hypothesis testing. This aligns well with quantitative approaches.',
      interpretivism: 'You selected Interpretivism, which focuses on understanding subjective meanings. This aligns well with qualitative approaches.',
      pragmatism: 'You selected Pragmatism, which is flexible about methods. This works well with mixed methods research.',
      critical_realism: 'You selected Critical Realism, which seeks to uncover underlying mechanisms. This can work with both quantitative and qualitative approaches.',
      transformative: 'You selected a Transformative approach, which emphasizes social justice. This often uses participatory methods.'
    },
    approach: {
      quantitative: 'Quantitative research uses numerical data and statistical analysis to test hypotheses.',
      qualitative: 'Qualitative research uses non-numerical data to explore meanings and understand experiences.',
      mixed: 'Mixed methods combines both quantitative and qualitative approaches for a more comprehensive understanding.'
    }
  };

  return explanations[step]?.[selection] || '';
};
